<template>
  <v-container fluid class="list-sor">
    <v-row class="flex-grow-0">
      <h3>{{ $t('app_drawer.contract') }}</h3>
      <v-btn color="primary"
             class="ml-4"
             small
             v-if="canCreateContract"
             @click="createContract">
        <v-icon>mdi-plus</v-icon>
        New
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <ContractList full-height
                      :refresh-trigger.sync="refreshTrigger"></ContractList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import SorList from "@/components/sor/SorList";
import ContractList from "@/components/contract/ContractList";
import CreateContractDialog from "@/components/contract/CreateContractDialog";
import {PERMISSIONS} from "@/constants";

export default {
  name: 'Contracts',
  components: {ContractList, SorList},
  setup(props, {root}) {
    const canCreateContract = computed(()=> {
      return _.some([PERMISSIONS.CREATE_CONTRACT], (p) => root.$store.getters.hasPermission(p))
    })
    const createContract = async function () {
      const contractId = await root.$dialog.showAndWait(CreateContractDialog, {
        showClose: false,
        persistent: true,
      });

      if (contractId) {
        root.$router.push({name: 'contract-detail', params: {contractId}});
      }
    }

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    return {
      canCreateContract,
      createContract,

      refreshTrigger,
      refresh,
    }
  }
}
</script>

<style lang="less">
.list-sor {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
